module.exports = __webpack_public_path__ + "media/FlyHorse.b045bda7.mp3";